// extracted by mini-css-extract-plugin
export var icon = "F_bq";
export var icons = "F_bw";
export var link = "F_bx";